import React from 'react';
import styled from 'styled-components';
import { Flex } from '@igooods/ui-kit';
import { FontWeight } from 'theme';
import Text from 'Components/Typography/Text';
import ThemedButton from 'Components/ThemedButton';
import { EnumButtonSize, EnumTheme } from 'constants/enums';
import { FontSize } from 'theme';
import { useUserAgentContext } from 'utils/userAgent/context';
import IosIcon from 'Components/Icon/IosIcon';
import AndroidIcon from 'Components/Icon/AndroidIcon';
import analyticsManager from 'utils/tagManager/manager';
import { EnumGtagEvents } from 'constants/enums';
import { getAppMetrikaLinkWithRef } from 'Containers/MobileApp/index';
import { URL } from 'constants/urlMaps';
import { mediaCustomDown } from 'theme/helpers/css';

const Button = styled(ThemedButton).attrs({
  size: EnumButtonSize.large,
  use: EnumTheme.roundBlack,
  fluid: true,
})`
  margin-top: auto;
  margin-bottom: 40px;
  ${mediaCustomDown(321)`
    margin-bottom: 30px;
  `}
`;

const StyledIosIcon = styled(IosIcon)`
  margin-right: 12px;
`;

const StyledAndroidIcon = styled(AndroidIcon)`
  margin-right: 8px;
`;

interface IMarketplaceButtonProps {
  onClick?: () => void;
  testId?: string;
}

const MarketplaceButton: React.FC<IMarketplaceButtonProps> = ({ onClick, testId }) => {
  const { isIOS, isAndroid } = useUserAgentContext();
  const handleClick = () => {
    analyticsManager.gtag(EnumGtagEvents.CLICK_MOBILE_DOWNLOAD, { type: 'new' });
    window.open(getAppMetrikaLinkWithRef(URL.mobile_appmetrica), '_blank');
    onClick && onClick();
  };

  return (
    <>
      {isIOS && (
        <Button onClick={handleClick} data-testid={testId}>
          <Flex middle center>
            <StyledIosIcon />
            <Text size={FontSize.m} fontWeight={FontWeight.semiBold}>
              Скачать в App Store
            </Text>
          </Flex>
        </Button>
      )}
      {isAndroid && (
        <Button onClick={handleClick} data-testid={testId}>
          <Flex middle center>
            <StyledAndroidIcon />
            <Text size={FontSize.m} fontWeight={FontWeight.semiBold}>
              Скачать в Google Play
            </Text>
          </Flex>
        </Button>
      )}
    </>
  );
};

export default MarketplaceButton;
